import { useTypeSafeMutation } from '@oresundsbron/api';
import { ValidationResult } from '@oresundsbron/use-form';
import { bizzValidationParser } from '@oresundsbron/validators';
import { pipe } from 'fp-ts/lib/function';
import { fold, tryCatchK, fromTask } from 'fp-ts/lib/TaskOption';
import { of } from 'fp-ts/lib/Task';
import { useCallback } from 'react';
import { z } from 'zod';

type BizzBody = z.input<typeof bizzValidationParser>;
export type AgreementType = BizzBody['agreementType'];

export function useValidateBizz() {
  const { mutateAsync } = useTypeSafeMutation(
    ['validate', 'bizz'],
    (req) => req.Bizz.validate
  );

  return useCallback(
    <T>(validationResult: ValidationResult<T>) =>
      (body: BizzBody) =>
        pipe(
          body,
          tryCatchK(mutateAsync),
          fold(
            () => of(validationResult),
            () => of(undefined)
          ),
          fromTask
        ),
    [mutateAsync]
  );
}
